import Api from './ApiRequest.js';

export default {
    getById: (id) => Api.get(`/training/category/${id}`),
    getAll: (params) => Api.get('/training/categories', params),
    getAllWithCount: (params) => Api.get('/training/categories/count', params),
    getAllByOrganisation: (organisationId) => Api.get(`/training/category/organisation/${organisationId}`),
    listByMyOrganisation: (params) => Api.post('/training/category/my-organisation', params),
    getRoots: () => Api.get('/training/categories/roots'),
    getChildren: (parentId) => Api.get(`/training/categories/${parentId}/children`),
    save: (entity) => Api.post('/training/category', entity),
    update: (id, entity) => Api.put(`/training/category/${id}`, entity),
    delete: (id) => Api.delete(`/training/category/${id}`),
    search: (searchText) => Api.get('/training/categories/search', {q: searchText}),
    addOrganisation: (id, organisationId) => Api.put(`/training/category/${id}/organisation`, {organisationId}),
    updateOrganisation: (id, organisationId, data) => Api.post(`/training/category/${id}/organisation/${organisationId}`, data),
    removeOrganisation: (id, organisationId) => Api.delete(`/training/category/${id}/organisation/${organisationId}`)
};